import React from "react"
import styled from "styled-components"
import { COLORS } from "../../constants"

export function Footer({ CITY }){
  const Container = styled.footer`
    padding: 20px 20px 20px 20px;
    font-size: 1.2em;
    text-align: center;
    color: ${COLORS.WHITE};
    background-color: ${CITY.COLOR};
  `

  return (
    <Container>
      GRT8 | 2020
    </Container>
  )
}
